module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/how-to-enjoy-sola-06-29788c029ddf4a03db6cbcd919eefa71.jpg";